import { TemplateEditorProps } from "@/shared/html-template-editor/html-template-editor/ui/html-template-editor";
import { useTranslations } from "use-intl";
import { useValidateProperties } from "@/shared/template-properties/model/use-validate-properties";
import { HtmlTemplateEditor } from "@/shared/html-template-editor";
import Form from "@/shared/form/form";

export function NotificationPrettyMessageInput({
  properties,
  ...props
}: TemplateEditorProps & {
  properties: string[];
}) {
  const t = useTranslations("TemplateForm");
  const validateParams = useValidateProperties({
    properties,
  });

  return (
    <Form.Item label={t("Pretty message")}>
      <HtmlTemplateEditor {...props} htmlRules={[validateParams]} />
    </Form.Item>
  );
}
